<template>
	<div id="main_page">
		<!-- <nav class="navbar is-light">
				<div class="navbar-menu">
					<div class="navbar-start">
					
					</div>

					<div class="navbar-end">
					
						<router-link to="/login" class="navbar-item">
							<strong>Scholen login</strong>
						</router-link>
					</div>
				</div>
		</nav>-->
		<section class="hero">
			<div class="hero-body">
				<div class="container">
					<h1 class="title">CRESSCUR</h1>
					<h2 class="subtitle">Centraal Register voor <strong>SBO</strong> opleiding en <strong>Scholen</strong> Curaçao.</h2>
				</div>
			</div>
		</section>
		<nav class="navbar is-primary">
			<div class="navbar-brand">
				<a class="navbar-item">
					<!-- <img :src="Logo" alt="EFO" /> -->
				</a>
				<div class="navbar-burger" data-target="navMenu">
					<span></span>
					<span></span>
					<span></span>
				</div>
			</div>
			<div class="navbar-menu" id="navMenu">
				<div class="navbar-start">
					<!-- navbar items -->
					<router-link class="navbar-item" to="/">
						<strong>Opleidingen</strong>
					</router-link>
				</div>
			</div>
		</nav>
		<div class="section">
			<router-view name="sitecontent"></router-view>
		</div>
		<br>
		<footer class="footer">
			<div class="container has-text-centered has-text-white">
				<p>Centraal Register voor <b>SBO</b> opleiding en <b>Scholen</b> Curaçao.</p>
			</div>
		</footer>
		<nav class="navbar" style="background-color:#eeeeee;padding: 12px;">
			<nav class="level navbar-end">
				<div class="level-left">
					<div class="level-item"></div>
				</div>
				<div class="level-right">
					<div class="level-item"><b>Ministerio di Enseñansa, Siensia, Kultura & Deporte</b></div>
				</div>
			</nav>
		</nav>
	</div>
</template> 
 <script>
import school_img from "../assets/school.jpeg";
import Navbar from "@/components/site/Navbar";

export default {
	name: "main_page",
	components: {
		Navbar
	},
	data() {
		return {
			msg: "Main Navigation"
		};
	},
	created() {
		// fetch the data when the view is created and the data is
		// already being observed
		//his.fetchData();
	},
	methods: {
		navigate(destination) {
			this.$router.push({
				path: destination
			});
		}
	}
};
</script>
 
 <!-- Add "scoped" attribute to limit CSS to this component only -->
 <style scoped>
</style>